/**
 * Bounding box of every usable fix in the Redux positions map, as MapLibre
 * `[[minLng, minLat], [maxLng, maxLat]]`, or null when nothing is usable.
 * Null island (0,0) and non-finite coordinates are skipped: a tracker that
 * has never had a GPS fix reports 0,0 and would otherwise drag the first
 * view out to the Gulf of Guinea.
 */
export function fleetBounds(positions) {
  if (!positions || typeof positions !== 'object') return null;
  let minLng = Infinity, minLat = Infinity, maxLng = -Infinity, maxLat = -Infinity;
  let n = 0;
  for (const pos of Object.values(positions)) {
    const lat = pos?.latitude;
    const lng = pos?.longitude;
    if (typeof lat !== 'number' || typeof lng !== 'number') continue;
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) continue;
    if (lat === 0 && lng === 0) continue;
    if (Math.abs(lat) > 90 || Math.abs(lng) > 180) continue;
    if (lng < minLng) minLng = lng;
    if (lng > maxLng) maxLng = lng;
    if (lat < minLat) minLat = lat;
    if (lat > maxLat) maxLat = lat;
    n++;
  }
  return n ? [[minLng, minLat], [maxLng, maxLat]] : null;
}
